import { useState, useEffect } from "react";
import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import ToggleSwitch from "../../BaseComponents/Toggle/ToggleSwitch";
import styles from "./AddDepositModal.module.css";

const empty = {
  productType:     "Flights",
  exceptionType:   "no-deposit",
  alternativeRule: "",
  status:          true,
};

const toForm = (data) => {
  if (!data) return empty;
  return {
    productType:     data.productType     || "Flights",
    exceptionType:   data.exceptionType   || "no-deposit",
    alternativeRule: data.alternativeRule || "",
    status:          data.status          ?? true,
  };
};

const AddExceptionModal = ({ open, onClose, initialData, onSave, saveLoading = false }) => {
  const [form, setForm] = useState(() => toForm(initialData));
  const isEdit = !!initialData;

  useEffect(() => {
    if (open) setForm(toForm(initialData));
  }, [open, initialData]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = () => {
    if (form.exceptionType === "alternative" && !form.alternativeRule.trim()) return;
    onSave({ ...form });
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={`${isEdit ? "Edit" : "Add"} Product Exception`}
      width="480px"
      footer={
        <>
          <button className={styles.cancelBtn} onClick={onClose} disabled={saveLoading}>
            Cancel
          </button>
          <button
            className={`${styles.primaryBtn} ${saveLoading ? styles.primaryBtnLoading : ""}`}
            onClick={handleSubmit}
            disabled={saveLoading}
          >
            {saveLoading
              ? <><span className={styles.spinner} /> Saving…</>
              : isEdit ? "Save Changes" : "+ Add Exception"
            }
          </button>
        </>
      }
    >
      <div className={styles.formGrid}>

        {/* Product Type */}
        <div className={styles.field}>
          <label>Product Type</label>
          <select value={form.productType} onChange={(e) => set("productType", e.target.value)}>
            <option value="Flights">Flights</option>
            <option value="Hotels">Hotels</option>
            <option value="Insurance">Insurance</option>
            <option value="Packages">Packages</option>
          </select>
        </div>

        {/* Exception Type */}
        <div className={styles.field}>
          <label>Exception Type</label>
          <select value={form.exceptionType} onChange={(e) => set("exceptionType", e.target.value)}>
            <option value="no-deposit">No Deposit Required</option>
            <option value="alternative">Alternative Rule</option>
          </select>
        </div>

        {/* Alternative Rule — only shown when type is alternative */}
        {form.exceptionType === "alternative" && (
          <div className={`${styles.field} ${styles.fullWidth}`}>
            <label>Alternative Rule Name</label>
            <input
              placeholder="e.g. Standard Flight Deposit"
              value={form.alternativeRule}
              onChange={(e) => set("alternativeRule", e.target.value)}
            />
          </div>
        )}

        {/* Status Toggle */}
        <div className={styles.toggleRow}>
          <div className={styles.field}>
            <label>Status</label>
            <ToggleSwitch
              checked={form.status}
              onChange={() => set("status", !form.status)}
            />
          </div>
        </div>

      </div>

      <div className={styles.infoBox}>
        ⚠️ Product exceptions override the default deposit rule for the selected product type.
      </div>
    </BaseModal>
  );
};

export default AddExceptionModal;